// Module
var code = "<div class=\"process-maps-page-header mobile-hide\"> <runner-page-description is-show=\"true\" page-header-text=\"Process Maps\" page-description=\"A list of Process Maps published to you.\" help-link=\"{{$ctrl.helpUri}}\"> </runner-page-description> </div> <process-maps-v2 back-from-state=\"$ctrl.backFromState\"></process-maps-v2> ";
// Exports
export default code;